module.exports = __webpack_public_path__ + "img/guidebook4.eb90c5da.png";